export const getErrorStore = initialStore => {
  const store = initialStore;
  const observers = {};

  const notify = () => {
    Object.keys(observers).forEach(key => observers[key](store));
  };

  return {
    addObserver(key, observer) {
      observers[key] = observer;
      observer(store);
    },
    removeObserver(key) {
      delete observers[key];
    },
    addError() {
      store.hasError = true;
      notify();
    },
    reset() {
      store.hasError = false;
      notify();
    },
  };
};

export default getErrorStore({ hasError: false });
